<template>


    <div>
        <v-app>
            <v-skeleton-loader v-if="loading" v-bind="attrs" type="article, article"></v-skeleton-loader>
            <!-- <v-parallax v-if="dtBasvuruSuresiBitti" dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
                <v-row align="center" justify="center">
                    <v-col class="text-center" cols="12">
                        <h1 class="text-h4 font-weight-thin mb-4">
                            Form Yönetim Sistemi
                        </h1>
                        <h4 class="subheading">
                            Başvuru yapmaya çalıştığınız form son başvuru tarihini geçtiğinden dolayı yayından
                            kaldırılmıştır.
                        </h4>
                    </v-col>
                </v-row>
            </v-parallax> -->

            <v-container v-if="dtUyari" class="fill-height d-flex justify-center align-center" fluid>
                <v-card elevation="12" class="pa-6" max-width="500" width="100%">
                    <v-card-title class="headline success--text justify-center">
                        {{ errorMessage.header }}
                    </v-card-title>

                    <v-card-text class="text-center">
                        <p>{{ errorMessage.label }}</p>

                        <v-btn color="primary"
                            :to="{ name: 'KullaniciLogin', params: { id: $route.params.id } }">Sisteme
                            Giriş</v-btn>
                        <!-- <v-alert border="left" colored-border type="success" elevation="2" class="mt-4 text-left">
                            <div><strong>Başvuru Numarası:</strong> #202507230001 </div>
                            <div><strong>Tarih:</strong> 23 Temmuz 2025</div>

                        </v-alert> -->
                    </v-card-text>

                    <!-- <v-card-actions class="justify-center mt-4">
        <v-btn color="success" dark @click="$router.push('/')">
          Ana Sayfaya Dön
        </v-btn>
      </v-card-actions> -->
                </v-card>
            </v-container>


            <v-form ref="frmItems" v-if="!loading && !dtUyari" class="my-5">


                <v-row>

                    <!-- <v-col v-for="field in fields" :key="field.id"   cols="12"
                    :md="field.cols || 12"
                    :sm="field.cols || 12"
                    :lg="field.cols || 12"
                    :xl="field.cols || 12"
                    >

                        <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :rules="field.rules"
                            @triggerEvent="triggerEvent">
                        </component>
                    </v-col> -->
                    <!-- v-if="checkVisibility(field)"  -->

                    <v-col v-for="field in NotGroupFields" :key="field.id" cols="12" :md="field.cols || 12" 
                        :sm="field.cols || 12" :lg="field.cols || 12" :xl="field.cols || 12">
                      
                        <component v-if="field.grpName" v-model="field.value" v-bind:is="field.cmpName" :ayar="field" 
                            :rules="field.rules" @triggerEvent="triggerEvent">
                            <template v-slot:group>
                                <v-row>
                                    <v-col v-for="fieldItem in listGrpNameFieldByGrpName(field.grpName)" cols="12"
                                        :md="fieldItem.cols || 12" :sm="fieldItem.cols || 12" :lg="fieldItem.cols || 12"
                                        :xl="fieldItem.cols || 12" :key="fieldItem.id">
                                        <component v-model="fieldItem.value" v-bind:is="fieldItem.cmpName"
                                            :ayar="fieldItem" :rules="fieldItem.rules" @triggerEvent="triggerEvent">
                                        </component>
                                    </v-col>
                                </v-row>

                            </template>

                        </component>
                        <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field" :rules="field.rules" 
                            @triggerEvent="triggerEvent">
                        </component>
                    </v-col>


                </v-row>



                <v-list subheader two-line class="my-5">


                    <!-- <v-list-item v-for="(field) in fields" :key="field.id">

             

                        <v-list-item-content class="pa-2">



                            <component v-model="field.value" v-bind:is="field.cmpName" :ayar="field"
                                :rules="field.rules" @triggerEvent="triggerEvent">
                            </component>





                        </v-list-item-content>



                    </v-list-item> -->
                    <v-list-item>
                        <v-list-item-content>
                            <table>
                                <tr>
                                    <td width="50"><span style="margin-bottom: 5px;">Güvenlik Kodu: </span></td>
                                    <td style="width: 100px;"><img :src="captchaImage"
                                            style="width: 100px; height: 40px;" alt="Captcha" /></td>
                                    <td style="width: 35px;"> <v-btn icon class="mx-2" fab dark color="teal"
                                            @click="loadCaptcha"><v-icon>mdi-refresh</v-icon></v-btn></td>
                                    <td><v-text-field :rules="rules" label="Güvenlik Kodu"
                                            v-model="userInputCaptha"></v-text-field>
                                    </td>
                                </tr>
                            </table>





                        </v-list-item-content>
                    </v-list-item>

                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn block color="primary" @click="dataSend()">
                        Kaydet
                    </v-btn>
                    <!-- <v-btn block color="primary" @click="dataSendDeneme()">
                        Kaydet
                    </v-btn> -->
                </v-card-actions>
            </v-form>
        </v-app>




    </div>


</template>
<script>
//import { rules } from '@/plugins/custom.js'
import { numberSF, textSF, radioSF, selectSF, dateSF, mailSF, checkSF } from '@/plugins/FieldDataFormat.js'
import FormService from '@/services/FormService'
import VText from '@/components/field_types/VText.vue';
import VNumber from '@/components/field_types/VNumber.vue';
import VRadio from '@/components/field_types/VRadio.vue';
import VSelect from '@/components/field_types/VSelect.vue';
import VDate from '@/components/field_types/VDate.vue';
import VMail from '@/components/field_types/VMail.vue';
import VCheck from '@/components/field_types/VCheck.vue';
import VHtmlEditor from '@/components/field_types/VHtmlEditor.vue';
import VFile from '@/components/field_types/VFile.vue';
import axios from 'axios';
import router from '@/router';
//import api from '@/plugins/axios';
export default {
    components: {
        VText, VNumber, VRadio, VSelect, VDate, VMail, VCheck, VHtmlEditor, VFile
    },
    name: 'HelloWorld',

    data: () => ({
        btnRedirectLogin: false,
        errorMessage: { header: "", label: "" },
        dtUyari: false,
        dtBasvuruSuresiBitti: false,
        loading: true,
        rules: [v => !!v || 'Boş Bırakılamaz.'],
        fields: [],
        captchaImage: null,
        userInputCaptha: null,

        itemTypeList: [
            textSF,
            numberSF,
            radioSF,
            selectSF,
            dateSF,
            mailSF,
            checkSF,


        ]

    }),
    created() {
        // this.validate()
        this.dataBind()
        this.loadCaptcha();
    },
    watch: {

        // selectedField: {
        //     immediate: true,
        //     handler() {

        //     },
        //     deep: true
        // }
    },
    computed: {
        listItems() {
            const result = Object.groupBy(this.fields, ({ grpName }) => grpName);
            return result;
        },
        NotGroupFields() {

            let result = this.fields.filter(x => !x.grpName || (!!x.grpName && x.type == "html"));

            result.forEach(obj => {

                if (!Object.prototype.hasOwnProperty.call(obj, "visibleIf")) {
                    obj.visibleIf = { goster: "goster", logic: "AND", conditions: [] };
                }

            });
console.log("Deneme",result);
            result = result.filter(field => this.checkVisibility(field));
            //const result2 = this.fields.filter(x => !!x.grpName && x.type == "html");

            return result;
            //return [...result, ...result2];
        },
        getUrl() {

            return process.env.VUE_APP_APIURL

        },

        validateDurumu() {


            // let value={id:this.$route.params.id,colums:fields.map(m=>({id:m.id,value:m.value}))};

            // console.log("object",value);



            return this.$refs.frmItems;
            // return   this.$refs.frmItems.validate();
        }
    },
    methods: {
        checkVisibility(field) {

            if (field.visibleIf.conditions.length==0 ) {
                return true;
            }


            // if (!field.visibleIf) {
            //     return false;
            // } else {
            //     if (field.visibleIf.conditions.length == 0) {
            //         return false;
            //     }

            // }


            const evaluateGroup = (group) => {
                const { logic = "AND", conditions = [] } = group;

                const results = conditions.map(cond => {
                    if (cond.conditions) {
                        // Nested group
                
                        return evaluateGroup(cond);
                    } else {
                        // Tek koşul
                        // console.log("this.formData",this.fields,cond.field);
                        // console.log("this.Find",this.fields.find(m => m.id.localeCompare(cond.field) ));
             
                         const targetObject = this.fields.find(m => m.id.localeCompare(cond.field)==0);
                            // console.log("cond.fieldxx", cond.field);
                          console.log("Fields", this.fields);
                         console.log("targetObject2",targetObject);
                        const targetValue = targetObject.value;// [cond.field];
                        console.log("Fields", this.fields);
                        console.log("cond.field", cond.field);
                        const { operator = "equals", value } = cond;
                        console.log("Secili Combobox", targetValue, "Text", value, "--,", targetValue === value, "-------------", field.value);
                        switch (operator) {
                            case "equals": return targetValue === value;
                            case "notEquals": return targetValue !== value;
                            case "contains": return targetValue && targetValue.toString().includes(value);
                            case "greater": return Number(targetValue) > Number(value);
                            case "greaterOrEqual": return Number(targetValue) >= Number(value);
                            case "less": return Number(targetValue) < Number(value);
                            case "lessOrEqual": return Number(targetValue) <= Number(value);
                            default: return true;
                        }
                    }
                });

                return logic === "AND"
                    ? results.every(Boolean)
                    : results.some(Boolean);
            };
            if (field.visibleIf.goster == "gizle" && evaluateGroup(field.visibleIf)) {
                field.value = "";
            }

            return field.visibleIf.goster == "goster" ? evaluateGroup(field.visibleIf) : !evaluateGroup(field.visibleIf);
        },
        listGrpNameFieldByGrpName(grpName) {
            let selected = this.fields.filter(m => m.type != "html" && m.grpName == grpName)

            return selected;
        },
        reset() {
            console.log("Form reset Çalıştı",);
            this.$refs.frmItems.reset();
        },
        loadCaptcha() {


            axios.get(process.env.VUE_APP_APIURL + '/api/captcha/generate', {
                withCredentials: true, // session için gerekli

            }
            ).then((result) => {
                console.log("loadCaptcha", result);
                this.captchaImage = result.data.image;
                // this.$toast.success("Başarılı bir şekilde kaydedilmiştir.")
            }).catch((err) => {
                this.$toast.warning(err)
            });



            // const res = fetch('https://localhost:7211/api/captcha/generate', {
            //     credentials: 'include' // session için gerekli
            // });
            // res.then((result) => {
            //     console.log("loadCaptcha", result);
            //     const data = result.json();
            //     this.captchaImage = data.image;
            // }).catch((err) => {

            // });


        },



        async dataSend() {



            if (this.$refs.frmItems.validate()) {
                const formData = new FormData();
                let currentDataItems = this.fields.filter(m => m.type != "html");
                currentDataItems.forEach(element => {

                    if (element.type == "file") {
                        if (Array.isArray(element.value)) {
                            element.value.forEach(itemFile => {
                                console.log("ID", element.id, "ItemFile", itemFile);
                                formData.append(element.id, itemFile);
                            });
                        }
                        else {
                            formData.append(element.id, element.value);
                        }
                    }
                    else {
                        formData.append(element.id, element.value);
                    }


                });
                console.log("Form Data:", formData.values());



                try {
                    const returnApi = await axios.post(process.env.VUE_APP_APIURL + '/api/form/upload-dynamic/' + this.$route.params.id, formData, {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'code': this.userInputCaptha,


                        }
                    });

                    this.$emit("saveClick", returnApi);





                } catch (err) {

                    this.$toast.warning(err.response.data)

                }
            }








        },
        dataBind() {
            let this2 = this;


            FormService.listFormItems(this.$route.params.id).then(function (response) {
                // console.log("DAta bind:",response.data);
                this2.dtUyari = false;
                this2.loading = false;

                if (response.data.length > 0) {
                    this2.fields = response.data.map(m => { let value = JSON.parse(m); value.value = ""; return value });
                }
                else {
                    this2.fields = [];
                }



            }).catch((err) => {

                this2.errorMessage = err.response.data;
                this2.loading = false;
                this2.dtUyari = true;



            });
        },
        triggerEvent(e) {
            // console.log("triggerEvent Parameter", e.id);
            let triggeredItem = this.fields.find(m => m.id == e.id);
            // console.log("triggerEvent triggeredItem", triggeredItem);
            triggeredItem.store = [...e.values];
        },

    }

}
</script>
<style scoped>
.theme--light.v-application {
    background: none !important;
}
</style>
